import axios from '@/utils/axios-config';

/*
===============================|> All Checkout APis <|===============================
01 |--> get Regions,
02 |--> get User addresses,
03 |--> get available shipping methods,
04 |--> add bundle products to cart,
05 |--> get available payments,
===============================|> All Checkout APis <|===============================
*/

// 01- ============= get regions data
const getRegions = async (handshake) => {
  let config = {
    method: 'get',
    url: '/mstore/region',
    headers: {
      Authorization: `Bearer ${handshake}`,
    },
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

// 02- ============= get regions data
const getUserAddresses = async (handshake, mage) => {
  let config = {
    method: 'get',
    url: '/customer/address',
    headers: {
      Authorization: `Bearer ${handshake}`,
      mage: 'Bearer ' + mage,
    },
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

// 03- ============= get Shipping Methods,
const getShippingMethods = async (
  handshake,
  mage,
  quote,
  region_id
  // city_id
) => {
  let config = {
    method: 'GET',
    url: `/mstore/available-shipping-methods/${quote}/${region_id}/${mage ? '0' : '1'
      }`,
    headers: {
      Authorization: `Bearer ${handshake}`,
      admin: 'Bearer ' + process.env.NEXT_PUBLIC_ADMIN_TOKEN,
    },
  };

  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

// 04- ============= get Shipping Address
const setShippingAddress = async (
  handshake,
  mage,
  quote,
  address,
  shipping_method,
  am_pickup
) => {
  // set default region id to riyadh
  // address.region_id = 609;

  address.telephone = "00966" + address.telephone?.slice(-9);
  const shipping_address = address;
  const billing_address = { ...address };
  let data = {
    addressInformation: {
      shipping_address,
      billing_address,
      shipping_method_code: 'flatrate',
      shipping_carrier_code: 'flatrate',
      // "shipping_carrier_code": "tablerate",
      // "shipping_method_code": "bestway"
    },
  };
  if (am_pickup !== null) {
    data.addressInformation.extension_attributes = {};
    data.addressInformation.extension_attributes.am_pickup = am_pickup;
  }

  let config = {
    method: 'post',
    url: '/cart/shippingaddress',
    headers: {
      Authorization: `Bearer ${handshake}`,
      quote: 'Bearer ' + quote,
      ...(mage ? { mage: `Bearer ${mage}` } : {}),
    },
    data: JSON.stringify(data),
  };
  if (mage) {
    config.headers.mage = 'Bearer ' + mage;
    //billing_address.save_in_address_book = 1;
  }

  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

// 05- get availanle payment methods
const getAvailablePayments = async (handshake, mage, quote) => {
  const checkQuote = mage ? '0' : '1';
  let config = {
    method: 'get',
    url: `/mstore/avilable-payment-methods/${quote}/${checkQuote}`,
    headers: {
      Authorization: `Bearer ${handshake}`,
      admin: 'Bearer ' + process.env.NEXT_PUBLIC_ADMIN_TOKEN,
    },
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const placeOrder = async (
  handshake,
  mage,
  quote,
  method,
  email,
  additional_data = null
) => {
  let data = {
    email,
    paymentMethod: {
      method,
    },
  };

  if (additional_data) {
    data.paymentMethod.additional_data = { ...additional_data };
  }

  let config = {
    method: 'post',
    url: '/cart/createOrder',
    maxBodyLength: Infinity,
    headers: {
      Authorization: 'Bearer ' + handshake,
      quote: 'Bearer ' + quote,
    },
    data: JSON.stringify(data),
  };
  if (mage) {
    config.headers.mage = 'Bearer ' + mage;
  }
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const getTamaraOrderSettings = async (handshake, orderId) => {
  let config = {
    method: 'get',
    url: `/tamara/get-order-settings/${orderId}`,
    headers: { Authorization: `Bearer ${handshake}` },
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const activeCart = async (handshake, order_id) => {
  let config = {
    method: 'post',
    url: '/cart/active',
    headers: { Authorization: `Bearer ${handshake}` },
    data: JSON.stringify({ order_id }),
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

export {
  getRegions,
  getUserAddresses,
  getShippingMethods,
  setShippingAddress,
  getAvailablePayments,
  placeOrder,
  getTamaraOrderSettings,
  activeCart,
};
